import { apiService } from '@app/services/api-service';
import {
  EAccountRiskCategory,
  EQrCodeSourceAction,
  EWebRiskVerdict,
  PageResponseQrCodeRiskLogGroupedOutDto,
  PageResponseQrCodeRiskLogOutDto,
  RiskWhitelistDomainOutDto,
} from '@app/swagger-types';
import { APIPaginationQueryParams } from '@app/models/api';

export abstract class QrCodeRiskLogApi {
  static async adminGetAll(params: APIQrCodeRiskLogQueryParams) {
    const { data } = await apiService.get<PageResponseQrCodeRiskLogOutDto>('/private/admin/qr-code-risk-log', {
      params,
    });
    return data;
  }

  static async adminGetGrouped(params: APIQrCodeRiskLogQueryParams) {
    const { data } = await apiService.get<PageResponseQrCodeRiskLogGroupedOutDto>(
      '/private/admin/qr-code-risk-log/grouped',
      { params }
    );
    return data;
  }

  static async adminMarkReviewed(qrCodeId: string, reviewed: boolean) {
    await apiService.patch(`/private/admin/qr-code-risk-log/by-qr-code/${qrCodeId}/reviewed`, null, {
      params: { reviewed },
    });
  }

  static async adminBlock(qrCodeId: string) {
    await apiService.patch(`/private/admin/qr-code-risk-log/by-qr-code/${qrCodeId}/block`);
  }

  static async adminUnblock(qrCodeId: string) {
    await apiService.patch(`/private/admin/qr-code-risk-log/by-qr-code/${qrCodeId}/unblock`);
  }

  static async adminGetWhitelistDomains() {
    const { data } = await apiService.get<RiskWhitelistDomainOutDto[]>(
      '/private/admin/qr-code-risk-log/whitelist-domains'
    );
    return data;
  }

  static async adminAddWhitelistDomain(domain: string) {
    const { data } = await apiService.post<RiskWhitelistDomainOutDto>(
      '/private/admin/qr-code-risk-log/whitelist-domains',
      {
        domain,
      }
    );
    return data;
  }

  static async adminRemoveWhitelistDomain(id: string) {
    await apiService.delete(`/private/admin/qr-code-risk-log/whitelist-domains/${id}`);
  }
}

export type APIQrCodeRiskLogQueryParams = APIPaginationQueryParams & {
  wouldBlock?: boolean;
  accountCategory?: EAccountRiskCategory;
  sourceAction?: EQrCodeSourceAction;
  webRiskVerdict?: EWebRiskVerdict;
  qrCodeId?: string;
  reviewed?: boolean;
};
